import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TextField, Grid, Button } from "@mui/material";
import { db } from "../config/firebaseConfig";
import {
  collection,
  doc,
  updateDoc,
  onSnapshot,
  query,
  orderBy,
} from "@firebase/firestore";
import Success from "../Common/Success";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditDialog({ btnOpen, id }) {
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  // this one is storing all data from firebase
  const [data, setData] = React.useState([]);
  // edit data here
  const [editData, setEditData] = React.useState({
    avatar: "",
    brand: "",
    caption: "",
    description: "",
    email: "",
    engine: "",
    fuelType: "",
    gasoline: "",
    id: "",
    featureLink: [],
    mileage: "",
    model: "",
    name: "",
    transmission: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // get all data from firebase
  React.useEffect(
    () =>
      onSnapshot(
        query(collection(db, "carPost"), orderBy("timestamp", "desc")),
        (snapshot) => {
          setData(
            snapshot.docs?.map((doc) => {
              return {
                id: doc.id,
                ...doc.data(),
              };
            })
          );
        }
      ),
    []
  );

  React.useEffect(() => {
    const result = data.filter((item) => item.id === id);
    setEditData({
      avatar: (result && result[0]?.avatar) || "",
      brand: result && result[0]?.brand,
      caption: (result && result[0]?.caption) || "",
      description: result && result[0]?.description,
      email: result && result[0]?.email,
      engine: result && result[0]?.engine,
      fuelType: result && result[0]?.fuelType,
      gasoline: result && result[0]?.gasoline,
      id: result && result[0]?.id,
      featureLink: result && result[0]?.featureLink,
      mileage: result && result[0]?.mileage,
      model: result && result[0]?.model,
      name: result && result[0]?.name,
      transmission: result && result[0]?.transmission,
    });
    setSelectedFile(result && result[0]?.featureLink);
  }, [data, id]);

  const handleChange = (prop) => (event) => {
    setEditData({ ...editData, [prop]: event.target.value });
  };

  const updateUser = async (id) => {
    const userDoc = doc(db, "carPost", id);
    await updateDoc(userDoc, editData);
    setOpen(false);
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
    }, 3000);
  };

  console.log(editData, "editData");
  return (
    <div>
      {success && <Success msg="Edit Successful submited" />}
      <Button
        variant="text"
        onClick={handleClickOpen}
        style={{ width: "100%", height: "100%" }}
      >
        {btnOpen}
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Edit Details</DialogTitle>
        <DialogContent>
          <div className="dashboard-layout">
            <>
              <div style={{ marginTop: "20px" }}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  alignContent="center"
                >
                  <Grid
                    container
                    spacing={2}
                    item
                    lg={12}
                    sm={12}
                    md={12}
                    xs={12}
                  >
                    <Grid
                      item
                      container
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "10px",
                      }}
                    >
                      {selectedFile?.map((image) => (
                        <Grid
                          item
                          md={2}
                          lg={2}
                          sm={4}
                          xs={6}
                          className="imageComponent"
                          style={{ margin: "3px" }}
                        >
                          <img
                            src={image}
                            alt="the-img"
                            style={{ borderRadius: "5px" }}
                          />
                        </Grid>
                      ))}
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        id="email"
                        name="email"
                        placeholder="email"
                        disabled={false}
                        variant="standard"
                        style={{ width: "100%" }}
                        type="email"
                        required
                        value={editData?.email}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        required
                        id="name"
                        name="name"
                        disabled={false}
                        placeholder="name"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.name}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        required
                        id="brand"
                        name="brand"
                        placeholder="Brand"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.brand}
                        onChange={handleChange("brand")}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        required
                        id="model"
                        name="model"
                        placeholder="Model"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.model}
                        onChange={handleChange("model")}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        required
                        id="fuel"
                        name="fuelType"
                        placeholder="Fuel type"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.fuelType}
                        onChange={handleChange("fuelType")}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        required
                        id="gasoline"
                        name="gasoline"
                        placeholder="Gasoline"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.gasoline}
                        onChange={handleChange("gasoline")}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <TextField
                        required
                        id="Transmission"
                        name="transmission"
                        placeholder="Transmission"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.transmission}
                        onChange={handleChange("transmission")}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <TextField
                        required
                        id="Engine"
                        name="engine"
                        placeholder="Engine"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.engine}
                        onChange={handleChange("engine")}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <TextField
                        required
                        id="Mileage"
                        name="mileage"
                        placeholder="Mileage"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.mileage}
                        onChange={handleChange("mileage")}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        required
                        id="Description"
                        name="description"
                        placeholder="Description"
                        variant="standard"
                        style={{ width: "100%" }}
                        value={editData?.description}
                        onChange={handleChange("description")}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Button
                  style={{
                    display: "block",
                    width: "30%",
                    margin: "30px auto",
                  }}
                  variant="contained"
                  type="submit"
                  onClick={() => updateUser(id)}
                >
                  SUBMIT
                </Button>
              </div>
            </>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
